import axios from 'axios'
import { getToken, removeToken } from './auth'
import { Message } from 'element-ui'
import router from '@/router'

const service = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL || '/api',
  timeout: 60000
})

service.interceptors.request.use(config => {
  const token = getToken()
  if (token) config.headers.Authorization = `Bearer ${token}`
  return config
})

service.interceptors.response.use(
  res => {
    if (res.data.code !== 0) {
      Message.error(res.data.message || '请求失败')
      return Promise.reject(res.data)
    }
    return res.data.data
  },
  err => {
    if (err.response?.status === 401) {
      removeToken()
      router.push('/login')
    }
    Message.error(err.response?.data?.message || '网络错误')
    return Promise.reject(err)
  }
)

export default service
